import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getVerifyMemberKey } from '../../utils/keys';
export const useVerifyMember = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const verifyMemberKey = getVerifyMemberKey();
    return useMutation((input) => client.auth.verifyMember(input, fields), { mutationKey: verifyMemberKey, ...useMutationOptions });
};
//# sourceMappingURL=useVerifyMember.js.map